import { IAjaxCreationMethod } from '@microsoft/portal-app/lib/auth';
import { addAjaxEpic } from '@microsoft/portal-app/lib/redux/createAjaxEpic';
import { IRootUserState } from '@microsoft/portal-app/lib/User/models';
import { Observable } from 'rxjs';
import { getUserPeopleInsightsSettingsReq } from '../../../redux/modules/graphApis';
import { IPrivacyAction } from '../../models/IPrivacyActions';
import { IPrivacyState } from '../../models/IPrivacyState';
import { PrivacyActions } from '../../models/PrivacyActions';
import { privacyRegistry as registry } from '../privacyRegistry';
import { IGetUserPeopleInsightsSettingsResponse } from './IUserPeopleInsightsSettingsResponse';

type UnwrapObservable<T> = T extends Observable<infer U> ? U : T;

export const getPeopleInsightsStatusResponse = (
  state: IPrivacyState,
  action: IPrivacyAction<UnwrapObservable<ReturnType<typeof getPeopleInsightsStatus>>>,
): IPrivacyState => {
  const payload = action.payload;
  if (payload) {
    let peopleInsightsServiceStateValue: IPrivacyState['peopleInsightsServiceState']['value'] = 'Enabled';
    if (!payload.IsEnabled) {
      peopleInsightsServiceStateValue = 'UserOptedOut';
    }
    const nextState: IPrivacyState = {
      ...state,
      peopleInsightsServiceState: {
        ...state.peopleInsightsServiceState,
        value: peopleInsightsServiceStateValue,
      },
    };

    return nextState;
  }
  return state;
};

export const getPeopleInsightsStatusFailed = (state: IPrivacyState): IPrivacyState => {
  return state;
};

export const getPeopleInsightsStatus = (ajax: IAjaxCreationMethod, _action: IPrivacyAction, state: IRootUserState) => {
  const userSettings = ajax.getJSON<IGetUserPeopleInsightsSettingsResponse>(getUserPeopleInsightsSettingsReq()).pipe();
  // Group membership check is excluded for now
  return userSettings;
};

addAjaxEpic(registry, PrivacyActions.getPeopleInsightsStatus, getPeopleInsightsStatus, {
  statePropertyName: 'peopleInsightsServiceState',
  loadingFailedReducer: getPeopleInsightsStatusFailed,
  loadingSuccessReducer: getPeopleInsightsStatusResponse,
});
